import { showEmeraldDialog } from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import {
  getTriButtonModalBottom,
  TriButtonModalBottomProps,
} from 'src/home-page/components/finish-transaction/tender-refund-message';

export const showIsPackageOpenModal = (
  onPackageOpen: () => void,
  onPackageClosed: () => void,
  onCancel: () => void,
): void => {
  const modalMessage = 'Package_open_Title';

  const triButtonModalBottomProps: TriButtonModalBottomProps = {
    closeButton: {
      label: 'ButtonCancelStyle_Cancel',
      onClick: onCancel,
    },
    middleButton: {
      label: 'Yes_CommandName',
      onClick: onPackageOpen,
    },
    rightButton: {
      label: 'No_CommandName',
      onClick: onPackageClosed,
    },
  };

  const refundModal: IMessageModal = {
    message: modalMessage,
    type: EmeraldDialogTypes.Status,
    buttonComponent: getTriButtonModalBottom(triButtonModalBottomProps),
  };

  showEmeraldDialog(refundModal);
};
